<template>
  <v-layout row justify-center>
    <v-dialog v-model="expGrpDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }" v-if="permissions.edit">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mt-5 mr-2"
              v-on="on"
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click="openForm()"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>Criar grupo de despesas</span>
        </v-tooltip>
        <!-- <v-btn color="primary" dark class="mb-2" @click="openForm()">Novo Cliente</v-btn> -->
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon dark @click="closeForm()">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <span>Fechar</span>
          </v-tooltip>
          <v-toolbar-title>Cadastro padrão os grupos de despesas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="doSave">Salvar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <h2
          class="title mx-4 mt-4 mb-1 text-xs-left"
          style="font-weight:400;"
        >Cadastrar grupo de despesa</h2>
        <div
          class="caption text-xs-left pt-3 pb-1 mx-4"
        >Preencha os campos abaixo, clique no botão adicionar planos de contas para criar novos planos e não esqueça de salvar</div>
        <!-- <RegisterExpenses :reloadUserExpenseGroups="getUserExpenses" /> -->
        <v-form
          ref="standardExpenseGroupForm"
          v-model="validForm"
          lazy-validation
          class="mx-5 mt-5 pt-0"
        >
          <v-layout wrap>
            <v-flex xs6 px-5 ml-1>
              <v-text-field
                type="text"
                v-model="formData.name"
                label="Descrição do grupo de despesa"
                :rules="$store.state.formRules.required"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4 px-5 ml-1>
              <v-text-field
                :disabled="formData.id ? true : false"
                type="text"
                v-model="formData.code"
                label="Código do grupo de despesa"
                :rules="$store.state.formRules.required"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
        <div
          class="caption text-xs-left pt-3 pb-2 px-5 mx-5 font-weight-bold"
        >Lista de planos de contas</div>
        <RegistrStandarAccountPlans
          :expenseGroupId="formData.id ? formData.id.toString() : ''"
          :buttonState="formData.id ? true : false"
          :openAccPlanForm="openAccPlanForm"
          :accPlansDialogShow="accPlansDialogShow"
          :closeAccPlanForm="closeAccPlanForm"
          :reloadList="getAccountPlans"
          :editData="editData"
        />
        <div class="px-5 mx-5">
          <v-data-table :headers="headers" :items="tableData" class="elevation-1">
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.code }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-center layout">
                <!-- <v-icon small class="mr-2" @click="editItem(props.item, 'viewForm')">remove_red_eye</v-icon> -->
                <v-btn class="mx-0" flat icon @click="editItem(props.item)">
                  <v-icon small>edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="!props.item.active"
                  flat
                  icon
                  @click="confirmToogleStatusItem(props.item)"
                >
                  <v-icon small>check</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.active"
                  flat
                  icon
                  @click="confirmToogleStatusItem(props.item)"
                >
                  <v-icon small>block</v-icon>
                </v-btn>
                <v-btn class="mx-0" flat icon @click="confirmDelAccPlan(props.item)">
                  <v-icon small>delete</v-icon>
                </v-btn>
              </td>
            </template>
            <template v-slot:no-data>
              <p>Ainda não há nenhum plano de conta para esse grupo de despesa.</p>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import RegistrStandarAccountPlans from './RegistrStandarAccountPlans.vue'
const defaultFormExpGrp = { name: '', code: '', id: '' }
export default {
  components: {
    RegistrStandarAccountPlans
  },
  computed: {
    permissions () {
      return this.$store.state.permissions.permissions.standardSystem
    }
  },
  methods: {
    editItem (data) {
      this.editData = data
      this.openAccPlanForm()
    },
    confirmDelAccPlan (data) {
      let obj = {
        message: `Você deseja excluir o plano de contas "${data.name}"?`,
        title: 'Excluir plano de contas',
        callback: _ => {
          this.delAccPlan(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },
    delAccPlan (data) {
      let obj = {
        url: '/api/defaultPlanAccount/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Plano de contas removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getAccountPlans()
      })
    },
    confirmToogleStatusItem (data) {
      let action = data.active ? 'desativar' : 'ativar'
      let obj = {
        message: `Você deseja ${action} o plano de contas "${data.name}"?`,
        title: `${
          data.active ? 'Desativar plano de contas' : 'Ativar plano de contas'
        }`,
        callback: _ => {
          this.toogleStatusItem(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },
    toogleStatusItem (data) {
      let obj = {
        url: '/api/defaultPlanAccount/disable_group/' + data.id,
        query: '',
        method: 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Status modificado com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getAccountPlans()
      })
    },
    getAccountPlans () {
      let dataSearch = {}
      dataSearch.params = {
        default_id: this.formData.id
      }
      let obj = {
        url: '/api/defaultPlanAccount',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        this.tableData = response.data
      })
    },
    openAccPlanForm () {
      if (!this.formData.id) {
        return
      }
      this.accPlansDialogShow = true
    },
    closeAccPlanForm () {
      this.editData = {}
      this.accPlansDialogShow = false
    },
    doSave () {
      if (!this.$refs.standardExpenseGroupForm.validate()) {
        return
      }
      if (this.formData.id) {
        this.formData.default_id = this.formData.id
      }
      this.saveExpenseGroup(this.formData)
    }
  },
  data () {
    return {
      editData: {},
      accPlansDialogShow: false,
      formData: { ...defaultFormExpGrp },
      validForm: true,
      headers: [
        { align: 'left', text: 'Código', sortable: false, value: 'code' },
        {
          text: 'Descrição do plano de contas',
          value: 'name',
          sortable: false,
          align: 'left'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  },
  watch: {
    editDataExpGrp: function (val) {
      this.formData = { ...this.editDataExpGrp }
    },
    expGrpDialog: function (val) {
      this.tableData = []
      this.formData = { ...defaultFormExpGrp }
      this.$refs.standardExpenseGroupForm.resetValidation()
      if (val) {
        this.formData = { ...this.editDataExpGrp }
        if (this.formData.id) {
          this.getAccountPlans()
        }
      }
    }
  },
  props: {
    saveExpenseGroup: Function,
    editDataExpGrp: Object,
    expGrpDialog: Boolean,
    openForm: Function,
    closeForm: Function
  }
}
</script>

<style>
</style>
